import { render, staticRenderFns } from "./search-lists.vue?vue&type=template&id=455d4567&scoped=true&"
import script from "./search-lists.vue?vue&type=script&lang=js&"
export * from "./search-lists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455d4567",
  null
  
)

export default component.exports